import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Directive, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { defineCustomElements } from '@bh-digital-solutions/ui-toolkit/loader';

/* eslint-disable */
/* tslint:disable */
const proxyInputs = (Cmp, inputs) => {
    const Prototype = Cmp.prototype;
    inputs.forEach((item) => {
        Object.defineProperty(Prototype, item, {
            get() {
                return this.el[item];
            },
            set(val) {
                this.z.runOutsideAngular(() => (this.el[item] = val));
            },
            /**
             * In the event that proxyInputs is called
             * multiple times re-defining these inputs
             * will cause an error to be thrown. As a result
             * we set configurable: true to indicate these
             * properties can be changed.
             */
            configurable: true,
        });
    });
};
const proxyMethods = (Cmp, methods) => {
    const Prototype = Cmp.prototype;
    methods.forEach((methodName) => {
        Prototype[methodName] = function () {
            const args = arguments;
            return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
        };
    });
};
const proxyOutputs = (instance, el, events) => {
    events.forEach((eventName) => (instance[eventName] = new EventEmitter()));
};
const defineCustomElement = (tagName, customElement) => {
    if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) {
        customElements.define(tagName, customElement);
    }
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
    const decorator = function (cls) {
        const { defineCustomElementFn, inputs, methods } = opts;
        if (defineCustomElementFn !== undefined) {
            defineCustomElementFn();
        }
        if (inputs) {
            proxyInputs(cls, inputs);
        }
        if (methods) {
            proxyMethods(cls, methods);
        }
        return cls;
    };
    return decorator;
}

let BhA = class BhA {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhA.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhA, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhA.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhA, selector: "bh-a", inputs: { externalLink: "externalLink", font: "font", href: "href", isDisabled: "isDisabled", isFooter: "isFooter", leftIcon: "leftIcon", noUnderline: "noUnderline", rightIcon: "rightIcon", tabularwidth: "tabularwidth", target: "target", text: "text", textLimit: "textLimit", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhA = __decorate([
    ProxyCmp({
        inputs: ['externalLink', 'font', 'href', 'isDisabled', 'isFooter', 'leftIcon', 'noUnderline', 'rightIcon', 'tabularwidth', 'target', 'text', 'textLimit', 'type']
    })
], BhA);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhA, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-a',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['externalLink', 'font', 'href', 'isDisabled', 'isFooter', 'leftIcon', 'noUnderline', 'rightIcon', 'tabularwidth', 'target', 'text', 'textLimit', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAccordion = class BhAccordion {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
};
BhAccordion.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAccordion, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAccordion.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAccordion, selector: "bh-accordion", inputs: { header: "header", iconOrientation: "iconOrientation", isOpen: "isOpen", size: "size" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAccordion = __decorate([
    ProxyCmp({
        inputs: ['header', 'iconOrientation', 'isOpen', 'size']
    })
], BhAccordion);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAccordion, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-accordion',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['header', 'iconOrientation', 'isOpen', 'size'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhActionBar = class BhActionBar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['ctaClick', 'bhEventCtaClick']);
    }
};
BhActionBar.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhActionBar, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhActionBar.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhActionBar, selector: "bh-action-bar", inputs: { footerActions: "footerActions" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhActionBar = __decorate([
    ProxyCmp({
        inputs: ['footerActions']
    })
], BhActionBar);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhActionBar, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-action-bar',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['footerActions'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhActionMenu = class BhActionMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['opened', 'bhEventOpen', 'bhEventClose', 'bhEventSelected', 'bhEventChange', 'bhEventCtaClick']);
    }
};
BhActionMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhActionMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhActionMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhActionMenu, selector: "bh-action-menu", inputs: { additionalMenuItems: "additionalMenuItems", disableTooltip: "disableTooltip", flipHorizontal: "flipHorizontal", flipOffset: "flipOffset", iconOverride: "iconOverride", inlineAnchorId: "inlineAnchorId", isEllipsis: "isEllipsis", isInline: "isInline", isMultiSelect: "isMultiSelect", isOpen: "isOpen", isSearchable: "isSearchable", isSelectAll: "isSelectAll", isSmall: "isSmall", isUnselectable: "isUnselectable", menuItems: "menuItems", menuWidth: "menuWidth", placeholder: "placeholder", selectedValue: "selectedValue", tooltipIsInline: "tooltipIsInline", tooltipLeftPadding: "tooltipLeftPadding", tooltipPlacement: "tooltipPlacement" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhActionMenu = __decorate([
    ProxyCmp({
        inputs: ['additionalMenuItems', 'disableTooltip', 'flipHorizontal', 'flipOffset', 'iconOverride', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'menuItems', 'menuWidth', 'placeholder', 'selectedValue', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement']
    })
], BhActionMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhActionMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-action-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['additionalMenuItems', 'disableTooltip', 'flipHorizontal', 'flipOffset', 'iconOverride', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'menuItems', 'menuWidth', 'placeholder', 'selectedValue', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAlert = class BhAlert {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhAlert.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAlert, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAlert.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAlert, selector: "bh-alert", inputs: { alerts: "alerts", closeOnCtaClick: "closeOnCtaClick", dismissAfter: "dismissAfter", timeout: "timeout", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAlert = __decorate([
    ProxyCmp({
        inputs: ['alerts', 'closeOnCtaClick', 'dismissAfter', 'timeout', 'type']
    })
], BhAlert);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAlert, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-alert',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['alerts', 'closeOnCtaClick', 'dismissAfter', 'timeout', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAlertItem = class BhAlertItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['removeAlertItem', 'bhEventClose']);
    }
};
BhAlertItem.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAlertItem, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAlertItem.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAlertItem, selector: "bh-alert-item", inputs: { alertkey: "alertkey", dismissAfter: "dismissAfter", dismissible: "dismissible", index: "index", isOpened: "isOpened", message: "message", status: "status", timeout: "timeout", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAlertItem = __decorate([
    ProxyCmp({
        inputs: ['alertkey', 'dismissAfter', 'dismissible', 'index', 'isOpened', 'message', 'status', 'timeout', 'type']
    })
], BhAlertItem);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAlertItem, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-alert-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['alertkey', 'dismissAfter', 'dismissible', 'index', 'isOpened', 'message', 'status', 'timeout', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAppShell = class BhAppShell {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['isSettingsMenuOpenUpdate', 'bhEventSelected', 'bhEventChange', 'bhEventScroll']);
    }
};
BhAppShell.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAppShell, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAppShell.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAppShell, selector: "bh-app-shell", inputs: { applogo: "applogo", appname: "appname", headerLimit: "headerLimit", iconLinks: "iconLinks", isMenuOpen: "isMenuOpen", mobileViewLabel: "mobileViewLabel", navigation: "navigation", navigationSelected: "navigationSelected", settings: "settings", settingsSelected: "settingsSelected", type: "type", useremail: "useremail", userfirstname: "userfirstname", userimage: "userimage", userlastname: "userlastname" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAppShell = __decorate([
    ProxyCmp({
        inputs: ['applogo', 'appname', 'headerLimit', 'iconLinks', 'isMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'useremail', 'userfirstname', 'userimage', 'userlastname']
    })
], BhAppShell);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAppShell, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-app-shell',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['applogo', 'appname', 'headerLimit', 'iconLinks', 'isMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'useremail', 'userfirstname', 'userimage', 'userlastname'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAppShellMenu = class BhAppShellMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventSelected']);
    }
};
BhAppShellMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAppShellMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAppShellMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAppShellMenu, selector: "bh-app-shell-menu", inputs: { isMobileMenuOpen: "isMobileMenuOpen", isSettingsMenuOpen: "isSettingsMenuOpen", isSideMenuOpen: "isSideMenuOpen", mobileViewLabel: "mobileViewLabel", navigation: "navigation", navigationSelected: "navigationSelected", settings: "settings", settingsSelected: "settingsSelected", type: "type", userInfo: "userInfo" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAppShellMenu = __decorate([
    ProxyCmp({
        inputs: ['isMobileMenuOpen', 'isSettingsMenuOpen', 'isSideMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'userInfo']
    })
], BhAppShellMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAppShellMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-app-shell-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isMobileMenuOpen', 'isSettingsMenuOpen', 'isSideMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'userInfo'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAvatar = class BhAvatar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhAvatar.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAvatar, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAvatar.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAvatar, selector: "bh-avatar", inputs: { firstname: "firstname", image: "image", isActive: "isActive", isRing: "isRing", lastname: "lastname", size: "size", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAvatar = __decorate([
    ProxyCmp({
        inputs: ['firstname', 'image', 'isActive', 'isRing', 'lastname', 'size', 'type']
    })
], BhAvatar);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAvatar, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-avatar',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['firstname', 'image', 'isActive', 'isRing', 'lastname', 'size', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhAvatarGroup = class BhAvatarGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhAvatarGroup.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAvatarGroup, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhAvatarGroup.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhAvatarGroup, selector: "bh-avatar-group", inputs: { type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhAvatarGroup = __decorate([
    ProxyCmp({
        inputs: ['type']
    })
], BhAvatarGroup);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhAvatarGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-avatar-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhBadge = class BhBadge {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhBadge.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBadge, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhBadge.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhBadge, selector: "bh-badge", inputs: { color: "color", icon: "icon", isFluid: "isFluid", label: "label", offset: "offset", position: "position", theme: "theme", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhBadge = __decorate([
    ProxyCmp({
        inputs: ['color', 'icon', 'isFluid', 'label', 'offset', 'position', 'theme', 'type']
    })
], BhBadge);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBadge, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-badge',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['color', 'icon', 'isFluid', 'label', 'offset', 'position', 'theme', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhBarChart = class BhBarChart {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhBarChart.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBarChart, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhBarChart.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhBarChart, selector: "bh-bar-chart", inputs: { chartOptionOverride: "chartOptionOverride", data: "data", height: "height", option: "option", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhBarChart = __decorate([
    ProxyCmp({
        inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme']
    })
], BhBarChart);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBarChart, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-bar-chart',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhBreadcrumbs = class BhBreadcrumbs {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['opened', 'itemSelectedUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventChange', 'bhEventSelected']);
    }
};
BhBreadcrumbs.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBreadcrumbs, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhBreadcrumbs.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhBreadcrumbs, selector: "bh-breadcrumbs", inputs: { inlineAnchorId: "inlineAnchorId", isBorder: "isBorder", isInline: "isInline", items: "items", menuWidth: "menuWidth", selectedItem: "selectedItem" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhBreadcrumbs = __decorate([
    ProxyCmp({
        inputs: ['inlineAnchorId', 'isBorder', 'isInline', 'items', 'menuWidth', 'selectedItem']
    })
], BhBreadcrumbs);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhBreadcrumbs, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-breadcrumbs',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['inlineAnchorId', 'isBorder', 'isInline', 'items', 'menuWidth', 'selectedItem'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhButton = class BhButton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhButton.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButton, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhButton.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhButton, selector: "bh-button", inputs: { disableTooltip: "disableTooltip", isDisabled: "isDisabled", isFluid: "isFluid", isLoading: "isLoading", isSmall: "isSmall", label: "label", leftIcon: "leftIcon", rightIcon: "rightIcon", tooltipMessage: "tooltipMessage", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhButton = __decorate([
    ProxyCmp({
        inputs: ['disableTooltip', 'isDisabled', 'isFluid', 'isLoading', 'isSmall', 'label', 'leftIcon', 'rightIcon', 'tooltipMessage', 'type']
    })
], BhButton);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-button',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['disableTooltip', 'isDisabled', 'isFluid', 'isLoading', 'isSmall', 'label', 'leftIcon', 'rightIcon', 'tooltipMessage', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhButtonDropdown = class BhButtonDropdown {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['opened', 'bhEventOpen', 'bhEventClose', 'bhEventSelected', 'bhEventChange', 'bhEventCtaClick']);
    }
};
BhButtonDropdown.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonDropdown, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhButtonDropdown.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhButtonDropdown, selector: "bh-button-dropdown", inputs: { additionalMenuItems: "additionalMenuItems", flipOffset: "flipOffset", iconOverride: "iconOverride", isDisabled: "isDisabled", isEllipsis: "isEllipsis", isFluid: "isFluid", isInline: "isInline", isLoading: "isLoading", isMultiSelect: "isMultiSelect", isOpen: "isOpen", isSearchable: "isSearchable", isSelectAll: "isSelectAll", isSmall: "isSmall", isUnselectable: "isUnselectable", label: "label", leftIcon: "leftIcon", menuItems: "menuItems", menuWidth: "menuWidth", placeholder: "placeholder", rightIcon: "rightIcon", tooltipMessage: "tooltipMessage", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhButtonDropdown = __decorate([
    ProxyCmp({
        inputs: ['additionalMenuItems', 'flipOffset', 'iconOverride', 'isDisabled', 'isEllipsis', 'isFluid', 'isInline', 'isLoading', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'label', 'leftIcon', 'menuItems', 'menuWidth', 'placeholder', 'rightIcon', 'tooltipMessage', 'type']
    })
], BhButtonDropdown);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonDropdown, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-button-dropdown',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['additionalMenuItems', 'flipOffset', 'iconOverride', 'isDisabled', 'isEllipsis', 'isFluid', 'isInline', 'isLoading', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'label', 'leftIcon', 'menuItems', 'menuWidth', 'placeholder', 'rightIcon', 'tooltipMessage', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhButtonGroup = class BhButtonGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhButtonGroup.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonGroup, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhButtonGroup.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhButtonGroup, selector: "bh-button-group", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhButtonGroup = __decorate([
    ProxyCmp({})
], BhButtonGroup);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-button-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: [],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhButtonTabs = class BhButtonTabs {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['activeTabUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
};
BhButtonTabs.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonTabs, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhButtonTabs.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhButtonTabs, selector: "bh-button-tabs", inputs: { activeKey: "activeKey", isSmall: "isSmall", items: "items", menuWidth: "menuWidth", tooltipMessage: "tooltipMessage" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhButtonTabs = __decorate([
    ProxyCmp({
        inputs: ['activeKey', 'isSmall', 'items', 'menuWidth', 'tooltipMessage']
    })
], BhButtonTabs);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhButtonTabs, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-button-tabs',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['activeKey', 'isSmall', 'items', 'menuWidth', 'tooltipMessage'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhCard = class BhCard {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['ctaClick', 'bhEventCtaClick', 'bhEventOpen', 'bhEventClose']);
    }
};
BhCard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhCard, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhCard.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhCard, selector: "bh-card", inputs: { actionMenu: "actionMenu", border: "border", footerActions: "footerActions", headerActions: "headerActions", heading: "heading", icon: "icon", isExpandable: "isExpandable", isFocusable: "isFocusable", stopBubble: "stopBubble", subtext: "subtext" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhCard = __decorate([
    ProxyCmp({
        inputs: ['actionMenu', 'border', 'footerActions', 'headerActions', 'heading', 'icon', 'isExpandable', 'isFocusable', 'stopBubble', 'subtext']
    })
], BhCard);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhCard, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-card',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['actionMenu', 'border', 'footerActions', 'headerActions', 'heading', 'icon', 'isExpandable', 'isFocusable', 'stopBubble', 'subtext'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhCheckbox = class BhCheckbox {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhCheckbox.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhCheckbox, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhCheckbox.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhCheckbox, selector: "bh-checkbox", inputs: { isChecked: "isChecked", isDisabled: "isDisabled", isError: "isError", isIndeterminate: "isIndeterminate", isUnfocusable: "isUnfocusable", label: "label", message: "message", name: "name", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhCheckbox = __decorate([
    ProxyCmp({
        inputs: ['isChecked', 'isDisabled', 'isError', 'isIndeterminate', 'isUnfocusable', 'label', 'message', 'name', 'value']
    })
], BhCheckbox);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhCheckbox, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-checkbox',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isChecked', 'isDisabled', 'isError', 'isIndeterminate', 'isUnfocusable', 'label', 'message', 'name', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhChip = class BhChip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventClose', 'bhEventChange']);
    }
};
BhChip.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhChip, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhChip.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhChip, selector: "bh-chip", inputs: { color: "color", dismissible: "dismissible", icon: "icon", isDisabled: "isDisabled", label: "label", link: "link", plain: "plain", preSelect: "preSelect", selectedColor: "selectedColor", selectedTheme: "selectedTheme", size: "size", theme: "theme", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhChip = __decorate([
    ProxyCmp({
        inputs: ['color', 'dismissible', 'icon', 'isDisabled', 'label', 'link', 'plain', 'preSelect', 'selectedColor', 'selectedTheme', 'size', 'theme', 'type']
    })
], BhChip);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhChip, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-chip',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['color', 'dismissible', 'icon', 'isDisabled', 'label', 'link', 'plain', 'preSelect', 'selectedColor', 'selectedTheme', 'size', 'theme', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhChipGroup = class BhChipGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhChipGroup.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhChipGroup, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhChipGroup.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhChipGroup, selector: "bh-chip-group", inputs: { isOverflow: "isOverflow" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhChipGroup = __decorate([
    ProxyCmp({
        inputs: ['isOverflow']
    })
], BhChipGroup);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhChipGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-chip-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isOverflow'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhContent = class BhContent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhContent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhContent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhContent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhContent, selector: "bh-content", inputs: { backgroundColor: "backgroundColor", contentPush: "contentPush", isNoPadding: "isNoPadding", isSideMenuOpen: "isSideMenuOpen", progress: "progress", progressBarMode: "progressBarMode", showLogo: "showLogo", showProgressBar: "showProgressBar", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhContent = __decorate([
    ProxyCmp({
        inputs: ['backgroundColor', 'contentPush', 'isNoPadding', 'isSideMenuOpen', 'progress', 'progressBarMode', 'showLogo', 'showProgressBar', 'theme']
    })
], BhContent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhContent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-content',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['backgroundColor', 'contentPush', 'isNoPadding', 'isSideMenuOpen', 'progress', 'progressBarMode', 'showLogo', 'showProgressBar', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDataTable = class BhDataTable {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['getTableDataset', 'customHtmlElementClick', 'sortUpdate', 'bhEventCtaClick', 'bhEventChange']);
    }
};
BhDataTable.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDataTable, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDataTable.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDataTable, selector: "bh-data-table", inputs: { content: "content", option: "option", sortState: "sortState" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDataTable = __decorate([
    ProxyCmp({
        inputs: ['content', 'option', 'sortState']
    })
], BhDataTable);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDataTable, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-data-table',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['content', 'option', 'sortState'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDatePicker = class BhDatePicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhDatePicker.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDatePicker, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDatePicker.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDatePicker, selector: "bh-date-picker", inputs: { dateFormat: "dateFormat", disableHelper: "disableHelper", disableUserInput: "disableUserInput", disabled: "disabled", errorMessage: "errorMessage", id: "id", isInvalid: "isInvalid", isReadOnly: "isReadOnly", isRequired: "isRequired", label: "label", maxValue: "maxValue", minValue: "minValue", placeholder: "placeholder", reset: "reset", value: "value", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDatePicker = __decorate([
    ProxyCmp({
        inputs: ['dateFormat', 'disableHelper', 'disableUserInput', 'disabled', 'errorMessage', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'label', 'maxValue', 'minValue', 'placeholder', 'reset', 'value', 'width']
    })
], BhDatePicker);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDatePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-date-picker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['dateFormat', 'disableHelper', 'disableUserInput', 'disabled', 'errorMessage', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'label', 'maxValue', 'minValue', 'placeholder', 'reset', 'value', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDateRangePicker = class BhDateRangePicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhDateRangePicker.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDateRangePicker, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDateRangePicker.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDateRangePicker, selector: "bh-date-range-picker", inputs: { disableHelper: "disableHelper", disableUserInput: "disableUserInput", endDateLabel: "endDateLabel", errorMessage: "errorMessage", id: "id", isInvalid: "isInvalid", isReadOnly: "isReadOnly", isRequired: "isRequired", isReset: "isReset", reset: "reset", startDateLabel: "startDateLabel", value: "value", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDateRangePicker = __decorate([
    ProxyCmp({
        inputs: ['disableHelper', 'disableUserInput', 'endDateLabel', 'errorMessage', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'isReset', 'reset', 'startDateLabel', 'value', 'width']
    })
], BhDateRangePicker);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDateRangePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-date-range-picker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['disableHelper', 'disableUserInput', 'endDateLabel', 'errorMessage', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'isReset', 'reset', 'startDateLabel', 'value', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDateTimePicker = class BhDateTimePicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhDateTimePicker.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDateTimePicker, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDateTimePicker.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDateTimePicker, selector: "bh-date-time-picker", inputs: { dateErrorMessage: "dateErrorMessage", dateLabel: "dateLabel", disableHelper: "disableHelper", id: "id", isInvalid: "isInvalid", isReadOnly: "isReadOnly", isRequired: "isRequired", maxValue: "maxValue", minValue: "minValue", timeErrorMessage: "timeErrorMessage", timeFormat: "timeFormat", timeLabel: "timeLabel", value: "value", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDateTimePicker = __decorate([
    ProxyCmp({
        inputs: ['dateErrorMessage', 'dateLabel', 'disableHelper', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'maxValue', 'minValue', 'timeErrorMessage', 'timeFormat', 'timeLabel', 'value', 'width']
    })
], BhDateTimePicker);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDateTimePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-date-time-picker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['dateErrorMessage', 'dateLabel', 'disableHelper', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'maxValue', 'minValue', 'timeErrorMessage', 'timeFormat', 'timeLabel', 'value', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDialog = class BhDialog {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
};
BhDialog.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDialog, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDialog.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDialog, selector: "bh-dialog", inputs: { ctas: "ctas", header: "header", illustration: "illustration", isDismissible: "isDismissible", isOpen: "isOpen", message: "message" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDialog = __decorate([
    ProxyCmp({
        inputs: ['ctas', 'header', 'illustration', 'isDismissible', 'isOpen', 'message']
    })
], BhDialog);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDialog, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-dialog',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['ctas', 'header', 'illustration', 'isDismissible', 'isOpen', 'message'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDivider = class BhDivider {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhDivider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDivider, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDivider.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDivider, selector: "bh-divider", inputs: { marginBottom: "marginBottom", marginLeft: "marginLeft", marginRight: "marginRight", marginTop: "marginTop", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDivider = __decorate([
    ProxyCmp({
        inputs: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'type']
    })
], BhDivider);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDivider, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-divider',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDonutChart = class BhDonutChart {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhDonutChart.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDonutChart, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDonutChart.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDonutChart, selector: "bh-donut-chart", inputs: { chartOptionOverride: "chartOptionOverride", data: "data", height: "height", label: "label", legendLayout: "legendLayout", option: "option", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDonutChart = __decorate([
    ProxyCmp({
        inputs: ['chartOptionOverride', 'data', 'height', 'label', 'legendLayout', 'option', 'theme']
    })
], BhDonutChart);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDonutChart, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-donut-chart',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['chartOptionOverride', 'data', 'height', 'label', 'legendLayout', 'option', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhDropdown = class BhDropdown {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'bhEventSelected', 'bhEventChange', 'selected', 'opened']);
    }
};
BhDropdown.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDropdown, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhDropdown.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhDropdown, selector: "bh-dropdown", inputs: { flipOffset: "flipOffset", inlineAnchorId: "inlineAnchorId", isDisabled: "isDisabled", isEllipsis: "isEllipsis", isError: "isError", isFluid: "isFluid", isInline: "isInline", isItemPaddingRight: "isItemPaddingRight", isMultiSelect: "isMultiSelect", isOpen: "isOpen", isRequired: "isRequired", isSearchable: "isSearchable", isSelectAll: "isSelectAll", isSmall: "isSmall", isUnselectable: "isUnselectable", keyboardFocused: "keyboardFocused", label: "label", menuItems: "menuItems", menuWidth: "menuWidth", message: "message", placeholder: "placeholder", searchMode: "searchMode", selectedValue: "selectedValue", showAllLabel: "showAllLabel", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhDropdown = __decorate([
    ProxyCmp({
        inputs: ['flipOffset', 'inlineAnchorId', 'isDisabled', 'isEllipsis', 'isError', 'isFluid', 'isInline', 'isItemPaddingRight', 'isMultiSelect', 'isOpen', 'isRequired', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'keyboardFocused', 'label', 'menuItems', 'menuWidth', 'message', 'placeholder', 'searchMode', 'selectedValue', 'showAllLabel', 'value']
    })
], BhDropdown);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhDropdown, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-dropdown',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['flipOffset', 'inlineAnchorId', 'isDisabled', 'isEllipsis', 'isError', 'isFluid', 'isInline', 'isItemPaddingRight', 'isMultiSelect', 'isOpen', 'isRequired', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'keyboardFocused', 'label', 'menuItems', 'menuWidth', 'message', 'placeholder', 'searchMode', 'selectedValue', 'showAllLabel', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhError = class BhError {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventCtaClick', 'ctaClick']);
    }
};
BhError.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhError, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhError.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhError, selector: "bh-error", inputs: { ctas: "ctas", description: "description", errorNumber: "errorNumber", source: "source", title: "title" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhError = __decorate([
    ProxyCmp({
        inputs: ['ctas', 'description', 'errorNumber', 'source', 'title']
    })
], BhError);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhError, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-error',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['ctas', 'description', 'errorNumber', 'source', 'title'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhFooter = class BhFooter {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhFooter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhFooter, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhFooter.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhFooter, selector: "bh-footer", inputs: { cookiesHREF: "cookiesHREF", cookiesText: "cookiesText", logo: "logo", marginTop: "marginTop", privacyHREF: "privacyHREF", privacyText: "privacyText", showLogo: "showLogo", termsHREF: "termsHREF", termsText: "termsText", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhFooter = __decorate([
    ProxyCmp({
        inputs: ['cookiesHREF', 'cookiesText', 'logo', 'marginTop', 'privacyHREF', 'privacyText', 'showLogo', 'termsHREF', 'termsText', 'theme']
    })
], BhFooter);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhFooter, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-footer',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['cookiesHREF', 'cookiesText', 'logo', 'marginTop', 'privacyHREF', 'privacyText', 'showLogo', 'termsHREF', 'termsText', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhFormMessage = class BhFormMessage {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhFormMessage.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhFormMessage, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhFormMessage.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhFormMessage, selector: "bh-form-message", inputs: { isDisabled: "isDisabled", isError: "isError", message: "message" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhFormMessage = __decorate([
    ProxyCmp({
        inputs: ['isDisabled', 'isError', 'message']
    })
], BhFormMessage);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhFormMessage, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-form-message',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isDisabled', 'isError', 'message'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhHeader = class BhHeader {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventCtaClick']);
    }
};
BhHeader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhHeader, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhHeader.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhHeader, selector: "bh-header", inputs: { appname: "appname", closeSettingsMenu: "closeSettingsMenu", headerLimit: "headerLimit", iconLinks: "iconLinks", logo: "logo", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhHeader = __decorate([
    ProxyCmp({
        inputs: ['appname', 'closeSettingsMenu', 'headerLimit', 'iconLinks', 'logo', 'type']
    })
], BhHeader);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhHeader, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-header',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['appname', 'closeSettingsMenu', 'headerLimit', 'iconLinks', 'logo', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhIcon = class BhIcon {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventClick', 'bhEventOnMouseHover']);
    }
};
BhIcon.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIcon, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhIcon.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhIcon, selector: "bh-icon", inputs: { color: "color", href: "href", icon: "icon", size: "size", target: "target" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhIcon = __decorate([
    ProxyCmp({
        inputs: ['color', 'href', 'icon', 'size', 'target']
    })
], BhIcon);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIcon, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-icon',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['color', 'href', 'icon', 'size', 'target'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhIllustration = class BhIllustration {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhIllustration.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIllustration, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhIllustration.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhIllustration, selector: "bh-illustration", inputs: { description: "description", source: "source", title: "title" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhIllustration = __decorate([
    ProxyCmp({
        inputs: ['description', 'source', 'title']
    })
], BhIllustration);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIllustration, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-illustration',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['description', 'source', 'title'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhIncrementer = class BhIncrementer {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['focus', 'blur', 'bhEventInput', 'bhEventChange']);
    }
};
BhIncrementer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIncrementer, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhIncrementer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhIncrementer, selector: "bh-incrementer", inputs: { incrementFactor: "incrementFactor", isDisabled: "isDisabled", isError: "isError", isFluid: "isFluid", isReadOnly: "isReadOnly", label: "label", maxValue: "maxValue", message: "message", minValue: "minValue", placeholderNumber: "placeholderNumber", unit: "unit", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhIncrementer = __decorate([
    ProxyCmp({
        inputs: ['incrementFactor', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'label', 'maxValue', 'message', 'minValue', 'placeholderNumber', 'unit', 'value']
    })
], BhIncrementer);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhIncrementer, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-incrementer',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['incrementFactor', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'label', 'maxValue', 'message', 'minValue', 'placeholderNumber', 'unit', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhInlineDropdown = class BhInlineDropdown {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventChange', 'bhEventSelected', 'selected', 'opened']);
    }
};
BhInlineDropdown.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhInlineDropdown, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhInlineDropdown.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhInlineDropdown, selector: "bh-inline-dropdown", inputs: { flipOffset: "flipOffset", inlineAnchorId: "inlineAnchorId", isEllipsis: "isEllipsis", isInline: "isInline", isOpen: "isOpen", isSearchable: "isSearchable", isSmall: "isSmall", menuItems: "menuItems", menuWidth: "menuWidth", selectedValue: "selectedValue", typography: "typography", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhInlineDropdown = __decorate([
    ProxyCmp({
        inputs: ['flipOffset', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isOpen', 'isSearchable', 'isSmall', 'menuItems', 'menuWidth', 'selectedValue', 'typography', 'value']
    })
], BhInlineDropdown);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhInlineDropdown, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-inline-dropdown',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['flipOffset', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isOpen', 'isSearchable', 'isSmall', 'menuItems', 'menuWidth', 'selectedValue', 'typography', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhKpi = class BhKpi {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhKpi.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhKpi, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhKpi.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhKpi, selector: "bh-kpi", inputs: { icon: "icon", kpiTitle: "kpiTitle", stats: "stats", sub: "sub", sup: "sup", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhKpi = __decorate([
    ProxyCmp({
        inputs: ['icon', 'kpiTitle', 'stats', 'sub', 'sup', 'value']
    })
], BhKpi);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhKpi, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-kpi',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['icon', 'kpiTitle', 'stats', 'sub', 'sup', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhLineChart = class BhLineChart {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhLineChart.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhLineChart, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhLineChart.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhLineChart, selector: "bh-line-chart", inputs: { chartOptionOverride: "chartOptionOverride", data: "data", height: "height", option: "option", theme: "theme", yaxisallowstring: "yaxisallowstring" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhLineChart = __decorate([
    ProxyCmp({
        inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme', 'yaxisallowstring']
    })
], BhLineChart);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhLineChart, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-line-chart',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme', 'yaxisallowstring'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhList = class BhList {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhList.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhList, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhList.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhList, selector: "bh-list", inputs: { padding: "padding" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhList = __decorate([
    ProxyCmp({
        inputs: ['padding']
    })
], BhList);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhList, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-list',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['padding'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhMenu = class BhMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['multiselectChange', 'ctaClick', 'bhEventChange', 'bhEventSelected', 'bhEventInput', 'bhEventCtaClick', 'unselect', 'close']);
    }
};
BhMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhMenu, selector: "bh-menu", inputs: { clearSearchText: "clearSearchText", isDropDownMenu: "isDropDownMenu", isEllipsis: "isEllipsis", isFocused: "isFocused", isItemPaddingRight: "isItemPaddingRight", isMultiSelect: "isMultiSelect", isSearchable: "isSearchable", isSelectAll: "isSelectAll", isTypeAhead: "isTypeAhead", isUnselectable: "isUnselectable", keyboardFocused: "keyboardFocused", menuHeight: "menuHeight", menuItems: "menuItems", menuWidth: "menuWidth", placeholder: "placeholder", query: "query", searchMode: "searchMode", selected: "selected", tooltipIsInline: "tooltipIsInline", tooltipLeftPadding: "tooltipLeftPadding", tooltipPlacement: "tooltipPlacement" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhMenu = __decorate([
    ProxyCmp({
        inputs: ['clearSearchText', 'isDropDownMenu', 'isEllipsis', 'isFocused', 'isItemPaddingRight', 'isMultiSelect', 'isSearchable', 'isSelectAll', 'isTypeAhead', 'isUnselectable', 'keyboardFocused', 'menuHeight', 'menuItems', 'menuWidth', 'placeholder', 'query', 'searchMode', 'selected', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement']
    })
], BhMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['clearSearchText', 'isDropDownMenu', 'isEllipsis', 'isFocused', 'isItemPaddingRight', 'isMultiSelect', 'isSearchable', 'isSelectAll', 'isTypeAhead', 'isUnselectable', 'keyboardFocused', 'menuHeight', 'menuItems', 'menuWidth', 'placeholder', 'query', 'searchMode', 'selected', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhMenuItem = class BhMenuItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhMenuItem.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMenuItem, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhMenuItem.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhMenuItem, selector: "bh-menu-item", inputs: { chevron: "chevron", icon: "icon", id: "id", isFocusable: "isFocusable", isHovered: "isHovered", isKeyboardFocused: "isKeyboardFocused", isSelected: "isSelected", isSubmenuBackSelected: "isSubmenuBackSelected", label: "label", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhMenuItem = __decorate([
    ProxyCmp({
        inputs: ['chevron', 'icon', 'id', 'isFocusable', 'isHovered', 'isKeyboardFocused', 'isSelected', 'isSubmenuBackSelected', 'label', 'type']
    })
], BhMenuItem);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMenuItem, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-menu-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['chevron', 'icon', 'id', 'isFocusable', 'isHovered', 'isKeyboardFocused', 'isSelected', 'isSubmenuBackSelected', 'label', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhMobileMenu = class BhMobileMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhMobileMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMobileMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhMobileMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhMobileMenu, selector: "bh-mobile-menu", inputs: { isOpen: "isOpen", mobileViewLabel: "mobileViewLabel", navigation: "navigation", settings: "settings", useremail: "useremail", userfirstname: "userfirstname", userimage: "userimage", userlastname: "userlastname" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhMobileMenu = __decorate([
    ProxyCmp({
        inputs: ['isOpen', 'mobileViewLabel', 'navigation', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname']
    })
], BhMobileMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhMobileMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-mobile-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isOpen', 'mobileViewLabel', 'navigation', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhModal = class BhModal {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
};
BhModal.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhModal, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhModal.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhModal, selector: "bh-modal", inputs: { ctas: "ctas", header: "header", isDismissible: "isDismissible", isOpen: "isOpen", subheader: "subheader", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhModal = __decorate([
    ProxyCmp({
        inputs: ['ctas', 'header', 'isDismissible', 'isOpen', 'subheader', 'width']
    })
], BhModal);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhModal, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-modal',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['ctas', 'header', 'isDismissible', 'isOpen', 'subheader', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhNavMenu = class BhNavMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['navSubMenuOpened', 'navSubMenuClosed']);
    }
};
BhNavMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhNavMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhNavMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhNavMenu, selector: "bh-nav-menu", inputs: { navigation: "navigation", type: "type", withAppShellMenu: "withAppShellMenu" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhNavMenu = __decorate([
    ProxyCmp({
        inputs: ['navigation', 'type', 'withAppShellMenu']
    })
], BhNavMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhNavMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-nav-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['navigation', 'type', 'withAppShellMenu'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhPagination = class BhPagination {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['pageNumberChange', 'itemCountChange', 'dropdownOpened', 'bhEventChange', 'bhEventSelected']);
    }
};
BhPagination.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhPagination, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhPagination.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhPagination, selector: "bh-pagination", inputs: { itemCount: "itemCount", itemCountOptions: "itemCountOptions", numOfPagesToExpose: "numOfPagesToExpose", pagePreSelect: "pagePreSelect", refresh: "refresh", totalItemCount: "totalItemCount" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhPagination = __decorate([
    ProxyCmp({
        inputs: ['itemCount', 'itemCountOptions', 'numOfPagesToExpose', 'pagePreSelect', 'refresh', 'totalItemCount']
    })
], BhPagination);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhPagination, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-pagination',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['itemCount', 'itemCountOptions', 'numOfPagesToExpose', 'pagePreSelect', 'refresh', 'totalItemCount'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhPanel = class BhPanel {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
};
BhPanel.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhPanel, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhPanel.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhPanel, selector: "bh-panel", inputs: { header: "header", isOpen: "isOpen", isPadded: "isPadded", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhPanel = __decorate([
    ProxyCmp({
        inputs: ['header', 'isOpen', 'isPadded', 'width']
    })
], BhPanel);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhPanel, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-panel',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['header', 'isOpen', 'isPadded', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhProgressBar = class BhProgressBar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['progressComplete']);
    }
};
BhProgressBar.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhProgressBar, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhProgressBar.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhProgressBar, selector: "bh-progress-bar", inputs: { automaticTimeout: "automaticTimeout", mode: "mode", progress: "progress", size: "size" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhProgressBar = __decorate([
    ProxyCmp({
        inputs: ['automaticTimeout', 'mode', 'progress', 'size']
    })
], BhProgressBar);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhProgressBar, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-progress-bar',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['automaticTimeout', 'mode', 'progress', 'size'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhRadioButton = class BhRadioButton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhRadioButton.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhRadioButton, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhRadioButton.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhRadioButton, selector: "bh-radio-button", inputs: { isChecked: "isChecked", isDisabled: "isDisabled", isError: "isError", label: "label", name: "name", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhRadioButton = __decorate([
    ProxyCmp({
        inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value']
    })
], BhRadioButton);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhRadioButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-radio-button',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhScatterChart = class BhScatterChart {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhScatterChart.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhScatterChart, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhScatterChart.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhScatterChart, selector: "bh-scatter-chart", inputs: { chartOptionOverride: "chartOptionOverride", data: "data", height: "height", option: "option", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhScatterChart = __decorate([
    ProxyCmp({
        inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme']
    })
], BhScatterChart);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhScatterChart, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-scatter-chart',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSearch = class BhSearch {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['query', 'results', 'ctaClick', 'bhEventCtaClick']);
    }
};
BhSearch.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSearch, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSearch.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSearch, selector: "bh-search", inputs: { data: "data", disableFuzzySearch: "disableFuzzySearch", isButtonSearch: "isButtonSearch", isDisabled: "isDisabled", isError: "isError", isFluid: "isFluid", isRounded: "isRounded", isSmall: "isSmall", maxLength: "maxLength", onBlur: "onBlur", onFocus: "onFocus", placeholder: "placeholder", search: "search", searchParams: "searchParams", shouldTrim: "shouldTrim", type: "type", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSearch = __decorate([
    ProxyCmp({
        inputs: ['data', 'disableFuzzySearch', 'isButtonSearch', 'isDisabled', 'isError', 'isFluid', 'isRounded', 'isSmall', 'maxLength', 'onBlur', 'onFocus', 'placeholder', 'search', 'searchParams', 'shouldTrim', 'type', 'value']
    })
], BhSearch);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSearch, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-search',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['data', 'disableFuzzySearch', 'isButtonSearch', 'isDisabled', 'isError', 'isFluid', 'isRounded', 'isSmall', 'maxLength', 'onBlur', 'onFocus', 'placeholder', 'search', 'searchParams', 'shouldTrim', 'type', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSelectionGroup = class BhSelectionGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhSelectionGroup.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSelectionGroup, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSelectionGroup.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSelectionGroup, selector: "bh-selection-group", inputs: { isDisabled: "isDisabled", isError: "isError", isGrid: "isGrid", layout: "layout", message: "message" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSelectionGroup = __decorate([
    ProxyCmp({
        inputs: ['isDisabled', 'isError', 'isGrid', 'layout', 'message']
    })
], BhSelectionGroup);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSelectionGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-selection-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isDisabled', 'isError', 'isGrid', 'layout', 'message'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSettingsMenu = class BhSettingsMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['settingsSubmenuOpened', 'settingsSubmenuClosed']);
    }
};
BhSettingsMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSettingsMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSettingsMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSettingsMenu, selector: "bh-settings-menu", inputs: { isFocusable: "isFocusable", isMobile: "isMobile", isOpen: "isOpen", isSubmenuBackSelected: "isSubmenuBackSelected", settings: "settings", useremail: "useremail", userfirstname: "userfirstname", userimage: "userimage", userlastname: "userlastname" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSettingsMenu = __decorate([
    ProxyCmp({
        inputs: ['isFocusable', 'isMobile', 'isOpen', 'isSubmenuBackSelected', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname']
    })
], BhSettingsMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSettingsMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-settings-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isFocusable', 'isMobile', 'isOpen', 'isSubmenuBackSelected', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSlider = class BhSlider {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventInput', 'bhEventChange']);
    }
};
BhSlider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSlider, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSlider.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSlider, selector: "bh-slider", inputs: { isDisabled: "isDisabled", maxLabel: "maxLabel", maxValue: "maxValue", minLabel: "minLabel", minValue: "minValue", prefixText: "prefixText", size: "size", sliderLabel: "sliderLabel", suffixText: "suffixText", textOnly: "textOnly", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSlider = __decorate([
    ProxyCmp({
        inputs: ['isDisabled', 'maxLabel', 'maxValue', 'minLabel', 'minValue', 'prefixText', 'size', 'sliderLabel', 'suffixText', 'textOnly', 'value']
    })
], BhSlider);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSlider, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-slider',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isDisabled', 'maxLabel', 'maxValue', 'minLabel', 'minValue', 'prefixText', 'size', 'sliderLabel', 'suffixText', 'textOnly', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSpinner = class BhSpinner {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhSpinner.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSpinner, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSpinner.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSpinner, selector: "bh-spinner", inputs: { offset: "offset", position: "position", size: "size" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSpinner = __decorate([
    ProxyCmp({
        inputs: ['offset', 'position', 'size']
    })
], BhSpinner);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSpinner, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-spinner',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['offset', 'position', 'size'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhStatusIndicator = class BhStatusIndicator {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhStatusIndicator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhStatusIndicator, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhStatusIndicator.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhStatusIndicator, selector: "bh-status-indicator", inputs: { color: "color", isFluid: "isFluid", offset: "offset", position: "position", size: "size", theme: "theme" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhStatusIndicator = __decorate([
    ProxyCmp({
        inputs: ['color', 'isFluid', 'offset', 'position', 'size', 'theme']
    })
], BhStatusIndicator);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhStatusIndicator, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-status-indicator',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['color', 'isFluid', 'offset', 'position', 'size', 'theme'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhStepper = class BhStepper {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange', 'stepClick', 'complete']);
    }
};
BhStepper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhStepper, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhStepper.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhStepper, selector: "bh-stepper", inputs: { current: "current", layout: "layout", steps: "steps" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhStepper = __decorate([
    ProxyCmp({
        inputs: ['current', 'layout', 'steps']
    })
], BhStepper);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhStepper, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-stepper',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['current', 'layout', 'steps'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhSystemAlertItem = class BhSystemAlertItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['removeAlertItem', 'bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
};
BhSystemAlertItem.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSystemAlertItem, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhSystemAlertItem.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhSystemAlertItem, selector: "bh-system-alert-item", inputs: { alertkey: "alertkey", closeOnCtaClick: "closeOnCtaClick", ctas: "ctas", header: "header", index: "index", isOpen: "isOpen", message: "message", opacity: "opacity", status: "status", timestamp: "timestamp" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhSystemAlertItem = __decorate([
    ProxyCmp({
        inputs: ['alertkey', 'closeOnCtaClick', 'ctas', 'header', 'index', 'isOpen', 'message', 'opacity', 'status', 'timestamp']
    })
], BhSystemAlertItem);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhSystemAlertItem, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-system-alert-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['alertkey', 'closeOnCtaClick', 'ctas', 'header', 'index', 'isOpen', 'message', 'opacity', 'status', 'timestamp'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTabs = class BhTabs {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['activeTabUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
};
BhTabs.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTabs, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTabs.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTabs, selector: "bh-tabs", inputs: { activeKey: "activeKey", isBorder: "isBorder", isSmall: "isSmall", items: "items", menuWidth: "menuWidth" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTabs = __decorate([
    ProxyCmp({
        inputs: ['activeKey', 'isBorder', 'isSmall', 'items', 'menuWidth']
    })
], BhTabs);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTabs, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-tabs',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['activeKey', 'isBorder', 'isSmall', 'items', 'menuWidth'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTabularList = class BhTabularList {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventSelected', 'bhEventChange', 'bhEventCtaClick', 'bhEventAppended', 'bhEventScroll']);
    }
};
BhTabularList.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTabularList, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTabularList.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTabularList, selector: "bh-tabular-list", inputs: { header: "header", id: "id", isLoading: "isLoading", noDataAvailable: "noDataAvailable", option: "option", payload: "payload", refresh: "refresh", schema: "schema", selectedItems: "selectedItems" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTabularList = __decorate([
    ProxyCmp({
        inputs: ['header', 'id', 'isLoading', 'noDataAvailable', 'option', 'payload', 'refresh', 'schema', 'selectedItems']
    })
], BhTabularList);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTabularList, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-tabular-list',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['header', 'id', 'isLoading', 'noDataAvailable', 'option', 'payload', 'refresh', 'schema', 'selectedItems'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTextArea = class BhTextArea {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['changed', 'bhEventInput', 'bhEventChange']);
    }
};
BhTextArea.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTextArea, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTextArea.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTextArea, selector: "bh-text-area", inputs: { fluidHorz: "fluidHorz", fluidVert: "fluidVert", isDisabled: "isDisabled", isError: "isError", isRequired: "isRequired", label: "label", maxChar: "maxChar", messageText: "messageText", messageType: "messageType", placeholder: "placeholder", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTextArea = __decorate([
    ProxyCmp({
        inputs: ['fluidHorz', 'fluidVert', 'isDisabled', 'isError', 'isRequired', 'label', 'maxChar', 'messageText', 'messageType', 'placeholder', 'value']
    })
], BhTextArea);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTextArea, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-text-area',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['fluidHorz', 'fluidVert', 'isDisabled', 'isError', 'isRequired', 'label', 'maxChar', 'messageText', 'messageType', 'placeholder', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTextInput = class BhTextInput {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventInput', 'bhEventChange', 'bhEventBlur']);
    }
};
BhTextInput.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTextInput, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTextInput.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTextInput, selector: "bh-text-input", inputs: { endIcon: "endIcon", isDisabled: "isDisabled", isError: "isError", isFluid: "isFluid", isReadOnly: "isReadOnly", isRequired: "isRequired", isRounded: "isRounded", isSmall: "isSmall", isSmallWidth: "isSmallWidth", label: "label", maxLength: "maxLength", message: "message", onFocus: "onFocus", pattern: "pattern", placeholder: "placeholder", startIcon: "startIcon", type: "type", unit: "unit", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTextInput = __decorate([
    ProxyCmp({
        inputs: ['endIcon', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'isRequired', 'isRounded', 'isSmall', 'isSmallWidth', 'label', 'maxLength', 'message', 'onFocus', 'pattern', 'placeholder', 'startIcon', 'type', 'unit', 'value']
    })
], BhTextInput);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTextInput, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-text-input',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['endIcon', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'isRequired', 'isRounded', 'isSmall', 'isSmallWidth', 'label', 'maxLength', 'message', 'onFocus', 'pattern', 'placeholder', 'startIcon', 'type', 'unit', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTimePicker = class BhTimePicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange', 'bhEventInput']);
    }
};
BhTimePicker.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTimePicker, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTimePicker.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTimePicker, selector: "bh-time-picker", inputs: { disableHelper: "disableHelper", errorMessage: "errorMessage", format: "format", id: "id", isInvalid: "isInvalid", isReadOnly: "isReadOnly", isRequired: "isRequired", label: "label", value: "value", width: "width" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTimePicker = __decorate([
    ProxyCmp({
        inputs: ['disableHelper', 'errorMessage', 'format', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'label', 'value', 'width']
    })
], BhTimePicker);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTimePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-time-picker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['disableHelper', 'errorMessage', 'format', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'label', 'value', 'width'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTimeZonePicker = class BhTimeZonePicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhTimeZonePicker.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTimeZonePicker, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTimeZonePicker.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTimeZonePicker, selector: "bh-time-zone-picker", inputs: { isDisabled: "isDisabled", isError: "isError", isFluid: "isFluid", isRequired: "isRequired", isSmall: "isSmall", label: "label", menuWidth: "menuWidth", message: "message", placeholder: "placeholder", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTimeZonePicker = __decorate([
    ProxyCmp({
        inputs: ['isDisabled', 'isError', 'isFluid', 'isRequired', 'isSmall', 'label', 'menuWidth', 'message', 'placeholder', 'value']
    })
], BhTimeZonePicker);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTimeZonePicker, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-time-zone-picker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isDisabled', 'isError', 'isFluid', 'isRequired', 'isSmall', 'label', 'menuWidth', 'message', 'placeholder', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTitleWrapper = class BhTitleWrapper {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventCtaClick']);
    }
};
BhTitleWrapper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTitleWrapper, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTitleWrapper.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTitleWrapper, selector: "bh-title-wrapper", inputs: { cta: "cta", header: "header", subtext: "subtext", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTitleWrapper = __decorate([
    ProxyCmp({
        inputs: ['cta', 'header', 'subtext', 'type']
    })
], BhTitleWrapper);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTitleWrapper, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-title-wrapper',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['cta', 'header', 'subtext', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhToggle = class BhToggle {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventChange']);
    }
};
BhToggle.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhToggle, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhToggle.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhToggle, selector: "bh-toggle", inputs: { isChecked: "isChecked", isDisabled: "isDisabled", isError: "isError", label: "label", name: "name", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhToggle = __decorate([
    ProxyCmp({
        inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value']
    })
], BhToggle);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhToggle, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-toggle',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTokenDemo = class BhTokenDemo {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
BhTokenDemo.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTokenDemo, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTokenDemo.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTokenDemo, selector: "bh-token-demo", inputs: { tokens: "tokens" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTokenDemo = __decorate([
    ProxyCmp({
        inputs: ['tokens']
    })
], BhTokenDemo);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTokenDemo, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-token-demo',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['tokens'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTooltip = class BhTooltip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
};
BhTooltip.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTooltip, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTooltip.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTooltip, selector: "bh-tooltip", inputs: { hide: "hide", invisible: "invisible", isInline: "isInline", isLegend: "isLegend", isTitle: "isTitle", ismessage: "ismessage", legendData: "legendData", message: "message", placement: "placement", tooltipLeftPadding: "tooltipLeftPadding", tooltipMessageFromTop: "tooltipMessageFromTop", tooltipTitle: "tooltipTitle" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTooltip = __decorate([
    ProxyCmp({
        inputs: ['hide', 'invisible', 'isInline', 'isLegend', 'isTitle', 'ismessage', 'legendData', 'message', 'placement', 'tooltipLeftPadding', 'tooltipMessageFromTop', 'tooltipTitle']
    })
], BhTooltip);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTooltip, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-tooltip',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['hide', 'invisible', 'isInline', 'isLegend', 'isTitle', 'ismessage', 'legendData', 'message', 'placement', 'tooltipLeftPadding', 'tooltipMessageFromTop', 'tooltipTitle'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTree = class BhTree {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventSelected']);
    }
};
BhTree.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTree, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTree.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTree, selector: "bh-tree", inputs: { id: "id", option: "option", payload: "payload" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTree = __decorate([
    ProxyCmp({
        inputs: ['id', 'option', 'payload']
    })
], BhTree);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTree, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-tree',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['id', 'option', 'payload'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhTypeAhead = class BhTypeAhead {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selected', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
};
BhTypeAhead.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTypeAhead, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhTypeAhead.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhTypeAhead, selector: "bh-type-ahead", inputs: { data: "data", isDisabled: "isDisabled", isError: "isError", isFluid: "isFluid", isSmall: "isSmall", placeholder: "placeholder", value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhTypeAhead = __decorate([
    ProxyCmp({
        inputs: ['data', 'isDisabled', 'isError', 'isFluid', 'isSmall', 'placeholder', 'value']
    })
], BhTypeAhead);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhTypeAhead, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-type-ahead',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['data', 'isDisabled', 'isError', 'isFluid', 'isSmall', 'placeholder', 'value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhUploader = class BhUploader {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhUploadSucess', 'bhUploadStart', 'bhUploadError', 'bhUploadProgress', 'bhFileReject', 'bhFilesChanged', 'bhMaxFilesReachedChanged', 'bhUploadAbort', 'bhUploadBefore', 'bhUploadRequest', 'bhUploadResponse', 'bhUploadRetry']);
    }
};
BhUploader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhUploader, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhUploader.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhUploader, selector: "bh-uploader", inputs: { fileType: "fileType", headers: "headers", helpText: "helpText", id: "id", isDisabled: "isDisabled", isSmall: "isSmall", isTarget: "isTarget", label: "label", leftIcon: "leftIcon", maxFileSize: "maxFileSize", maxFiles: "maxFiles", method: "method", noAuto: "noAuto", target: "target", type: "type" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhUploader = __decorate([
    ProxyCmp({
        inputs: ['fileType', 'headers', 'helpText', 'id', 'isDisabled', 'isSmall', 'isTarget', 'label', 'leftIcon', 'maxFileSize', 'maxFiles', 'method', 'noAuto', 'target', 'type']
    })
], BhUploader);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhUploader, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-uploader',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['fileType', 'headers', 'helpText', 'id', 'isDisabled', 'isSmall', 'isTarget', 'label', 'leftIcon', 'maxFileSize', 'maxFiles', 'method', 'noAuto', 'target', 'type'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
let BhVerticalMenu = class BhVerticalMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bhEventSelected']);
    }
};
BhVerticalMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhVerticalMenu, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BhVerticalMenu.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BhVerticalMenu, selector: "bh-vertical-menu", inputs: { menuItems: "menuItems", selected: "selected" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
BhVerticalMenu = __decorate([
    ProxyCmp({
        inputs: ['menuItems', 'selected']
    })
], BhVerticalMenu);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BhVerticalMenu, decorators: [{
            type: Component,
            args: [{
                    selector: 'bh-vertical-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['menuItems', 'selected'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });

class ValueAccessor {
    constructor(el) {
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    writeValue(value) {
        this.el.nativeElement.value = this.lastValue = value == null ? '' : value;
    }
    handleChangeEvent(value) {
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.onChange(value);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.el.nativeElement.disabled = isDisabled;
    }
}
ValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ValueAccessor, host: { listeners: { "focusout": "_handleBlurEvent()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueAccessor, decorators: [{
            type: Directive,
            args: [{}]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { _handleBlurEvent: [{
                type: HostListener,
                args: ['focusout']
            }] } });

class BooleanValueAccessor extends ValueAccessor {
    constructor(el) {
        super(el);
    }
    writeValue(value) {
        this.el.nativeElement.checked = this.lastValue = value == null ? false : value;
    }
}
BooleanValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BooleanValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BooleanValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: BooleanValueAccessor, selector: "bh-checkbox, bh-radio-button, bh-toggle", host: { listeners: { "bhEventChange": "handleChangeEvent($event.target.isChecked)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BooleanValueAccessor,
            multi: true
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BooleanValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    /* tslint:disable-next-line:directive-selector */
                    selector: 'bh-checkbox, bh-radio-button, bh-toggle',
                    host: {
                        '(bhEventChange)': 'handleChangeEvent($event.target.isChecked)'
                    },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: BooleanValueAccessor,
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class NumericValueAccessor extends ValueAccessor {
    constructor(el) {
        super(el);
    }
    registerOnChange(fn) {
        super.registerOnChange(value => {
            fn(value === '' ? null : parseFloat(value));
        });
    }
}
NumericValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NumericValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
NumericValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: NumericValueAccessor, selector: "bh-slider", host: { listeners: { "bhEventChange": "handleChangeEvent($event.target.value)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NumericValueAccessor,
            multi: true
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NumericValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    /* tslint:disable-next-line:directive-selector */
                    selector: 'bh-slider',
                    host: {
                        '(bhEventChange)': 'handleChangeEvent($event.target.value)'
                    },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: NumericValueAccessor,
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class SelectValueAccessor extends ValueAccessor {
    constructor(el) {
        super(el);
    }
}
SelectValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
SelectValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: SelectValueAccessor, selector: "bh-dropdown, bh-inline-dropdown", host: { listeners: { "bhEventChange": "handleChangeEvent($event.target.value)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectValueAccessor,
            multi: true
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    /* tslint:disable-next-line:directive-selector */
                    selector: 'bh-dropdown, bh-inline-dropdown',
                    host: {
                        '(bhEventChange)': 'handleChangeEvent($event.target.value)'
                    },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SelectValueAccessor,
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class TextValueAccessor extends ValueAccessor {
    constructor(el) {
        super(el);
    }
}
TextValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TextValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: TextValueAccessor, selector: "bh-text-area, bh-text-input, bh-search, bh-type-ahead, bh-date-picker, bh-date-range-picker, bh-date-time-picker, bh-time-picker, bh-time-zone-picker, bh-incrementer", host: { listeners: { "bhEventChange": "handleChangeEvent($event.target.value)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TextValueAccessor,
            multi: true
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    /* tslint:disable-next-line:directive-selector */
                    selector: 'bh-text-area, bh-text-input, bh-search, bh-type-ahead, bh-date-picker, bh-date-range-picker, bh-date-time-picker, bh-time-picker, bh-time-zone-picker, bh-incrementer',
                    host: {
                        '(bhEventChange)': 'handleChangeEvent($event.target.value)'
                    },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TextValueAccessor,
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

defineCustomElements(window);
const DECLARATIONS = [
    // proxies
    BhA,
    BhAccordion,
    BhActionBar,
    BhActionMenu,
    BhAlert,
    BhAlertItem,
    BhAppShell,
    BhAppShellMenu,
    BhAvatar,
    BhAvatarGroup,
    BhBadge,
    BhBarChart,
    BhBreadcrumbs,
    BhButton,
    BhButtonDropdown,
    BhButtonGroup,
    BhButtonTabs,
    BhCard,
    BhCheckbox,
    BhChip,
    BhChipGroup,
    BhContent,
    BhDataTable,
    BhDatePicker,
    BhDateTimePicker,
    BhDateRangePicker,
    BhDialog,
    BhDivider,
    BhDonutChart,
    BhDropdown,
    BhError,
    BhFooter,
    BhFormMessage,
    BhHeader,
    BhIcon,
    BhIllustration,
    BhIncrementer,
    BhInlineDropdown,
    BhKpi,
    BhLineChart,
    BhList,
    BhMenu,
    BhMenuItem,
    BhMobileMenu,
    BhModal,
    BhNavMenu,
    BhPagination,
    BhPanel,
    BhProgressBar,
    BhRadioButton,
    BhScatterChart,
    BhSearch,
    BhSelectionGroup,
    BhSettingsMenu,
    BhSlider,
    BhSpinner,
    BhStatusIndicator,
    BhStepper,
    BhSystemAlertItem,
    BhTabs,
    BhTabularList,
    BhTextArea,
    BhTextInput,
    BhTimePicker,
    BhTimeZonePicker,
    BhTitleWrapper,
    BhToggle,
    BhTokenDemo,
    BhTooltip,
    BhTree,
    BhTypeAhead,
    BhUploader,
    BhVerticalMenu,
    // value accssessors
    BooleanValueAccessor,
    NumericValueAccessor,
    SelectValueAccessor,
    TextValueAccessor
];
class ComponentLibraryModule {
}
ComponentLibraryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComponentLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ComponentLibraryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: ComponentLibraryModule, declarations: [
        // proxies
        BhA,
        BhAccordion,
        BhActionBar,
        BhActionMenu,
        BhAlert,
        BhAlertItem,
        BhAppShell,
        BhAppShellMenu,
        BhAvatar,
        BhAvatarGroup,
        BhBadge,
        BhBarChart,
        BhBreadcrumbs,
        BhButton,
        BhButtonDropdown,
        BhButtonGroup,
        BhButtonTabs,
        BhCard,
        BhCheckbox,
        BhChip,
        BhChipGroup,
        BhContent,
        BhDataTable,
        BhDatePicker,
        BhDateTimePicker,
        BhDateRangePicker,
        BhDialog,
        BhDivider,
        BhDonutChart,
        BhDropdown,
        BhError,
        BhFooter,
        BhFormMessage,
        BhHeader,
        BhIcon,
        BhIllustration,
        BhIncrementer,
        BhInlineDropdown,
        BhKpi,
        BhLineChart,
        BhList,
        BhMenu,
        BhMenuItem,
        BhMobileMenu,
        BhModal,
        BhNavMenu,
        BhPagination,
        BhPanel,
        BhProgressBar,
        BhRadioButton,
        BhScatterChart,
        BhSearch,
        BhSelectionGroup,
        BhSettingsMenu,
        BhSlider,
        BhSpinner,
        BhStatusIndicator,
        BhStepper,
        BhSystemAlertItem,
        BhTabs,
        BhTabularList,
        BhTextArea,
        BhTextInput,
        BhTimePicker,
        BhTimeZonePicker,
        BhTitleWrapper,
        BhToggle,
        BhTokenDemo,
        BhTooltip,
        BhTree,
        BhTypeAhead,
        BhUploader,
        BhVerticalMenu,
        // value accssessors
        BooleanValueAccessor,
        NumericValueAccessor,
        SelectValueAccessor,
        TextValueAccessor], exports: [
        // proxies
        BhA,
        BhAccordion,
        BhActionBar,
        BhActionMenu,
        BhAlert,
        BhAlertItem,
        BhAppShell,
        BhAppShellMenu,
        BhAvatar,
        BhAvatarGroup,
        BhBadge,
        BhBarChart,
        BhBreadcrumbs,
        BhButton,
        BhButtonDropdown,
        BhButtonGroup,
        BhButtonTabs,
        BhCard,
        BhCheckbox,
        BhChip,
        BhChipGroup,
        BhContent,
        BhDataTable,
        BhDatePicker,
        BhDateTimePicker,
        BhDateRangePicker,
        BhDialog,
        BhDivider,
        BhDonutChart,
        BhDropdown,
        BhError,
        BhFooter,
        BhFormMessage,
        BhHeader,
        BhIcon,
        BhIllustration,
        BhIncrementer,
        BhInlineDropdown,
        BhKpi,
        BhLineChart,
        BhList,
        BhMenu,
        BhMenuItem,
        BhMobileMenu,
        BhModal,
        BhNavMenu,
        BhPagination,
        BhPanel,
        BhProgressBar,
        BhRadioButton,
        BhScatterChart,
        BhSearch,
        BhSelectionGroup,
        BhSettingsMenu,
        BhSlider,
        BhSpinner,
        BhStatusIndicator,
        BhStepper,
        BhSystemAlertItem,
        BhTabs,
        BhTabularList,
        BhTextArea,
        BhTextInput,
        BhTimePicker,
        BhTimeZonePicker,
        BhTitleWrapper,
        BhToggle,
        BhTokenDemo,
        BhTooltip,
        BhTree,
        BhTypeAhead,
        BhUploader,
        BhVerticalMenu,
        // value accssessors
        BooleanValueAccessor,
        NumericValueAccessor,
        SelectValueAccessor,
        TextValueAccessor] });
ComponentLibraryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComponentLibraryModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComponentLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DECLARATIONS,
                    exports: DECLARATIONS,
                    imports: [],
                    providers: []
                }]
        }] });

// DIRECTIVES

/**
 * Generated bundle index. Do not edit.
 */

export { BhA, BhAccordion, BhActionBar, BhActionMenu, BhAlert, BhAlertItem, BhAppShell, BhAppShellMenu, BhAvatar, BhAvatarGroup, BhBadge, BhBarChart, BhBreadcrumbs, BhButton, BhButtonDropdown, BhButtonGroup, BhButtonTabs, BhCard, BhCheckbox, BhChip, BhChipGroup, BhContent, BhDataTable, BhDatePicker, BhDateRangePicker, BhDateTimePicker, BhDialog, BhDivider, BhDonutChart, BhDropdown, BhError, BhFooter, BhFormMessage, BhHeader, BhIcon, BhIllustration, BhIncrementer, BhInlineDropdown, BhKpi, BhLineChart, BhList, BhMenu, BhMenuItem, BhMobileMenu, BhModal, BhNavMenu, BhPagination, BhPanel, BhProgressBar, BhRadioButton, BhScatterChart, BhSearch, BhSelectionGroup, BhSettingsMenu, BhSlider, BhSpinner, BhStatusIndicator, BhStepper, BhSystemAlertItem, BhTabs, BhTabularList, BhTextArea, BhTextInput, BhTimePicker, BhTimeZonePicker, BhTitleWrapper, BhToggle, BhTokenDemo, BhTooltip, BhTree, BhTypeAhead, BhUploader, BhVerticalMenu, BooleanValueAccessor, ComponentLibraryModule, NumericValueAccessor, SelectValueAccessor, TextValueAccessor };
